import React from "react"
import classnames from "classnames"

import * as styles from "./Card.module.css"
import { Link } from "gatsby"
import useDeviceType from "../../hooks/useDeviceType"
import { IGatsbyImageData } from "gatsby-plugin-image/dist/src/components/gatsby-image.browser"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

type BlogCardType = {
  author: string
  categories: Array<string>
  date: string
  summary: string
  title: string
  image?: IGatsbyImageData
  slug: string
  time: number
}

export const BlogCard = ({
  post,
  horizontal,
  featured,
}: {
  post: BlogCardType
  horizontal?: boolean
  featured?: boolean
}) => {
  const { author, categories, date, image, summary, title, slug, time } = post

  const DeviceType = useDeviceType()

  const gatsbyImage = image && getImage(image)

  return (
    <Link
      to={`/blog/post/${slug}`}
      className={classnames(
        styles.card,
        !image ? styles.NoImageCard : "",
        horizontal ? styles.horizontalCard : "",
        featured ? styles.featuredCard : ""
      )}
    >
      {horizontal && (
        <div className={styles.horizontalCard__image}>
          {gatsbyImage && (
            <GatsbyImage
              className={styles.image}
              image={gatsbyImage}
              alt={title}
            />
          )}
        </div>
      )}
      {featured && <div className={styles.featured}>Featured</div>}
      <div className={styles.top}>
        <span>{date}</span>
        <span className={styles.category}>{categories[0]}</span>
      </div>
      <div className={styles.info}>
        <span className={styles.title}>{title}</span>
        <span className={styles.author}>
          By: {author} <span className={styles.separator}>|</span>{" "}
          <span className={styles.time}>{time} min read</span>
        </span>
      </div>
      <div className={styles.main}>
        <p className={styles.summary}>
          {DeviceType === "desktop" || DeviceType === "tablet"
            ? summary
            : summary.slice(0, 256) + " ..."}
        </p>
        {!horizontal && (
          <div
            className={classnames(
              styles.imageContainer,
              !image ? styles.NoImage : ""
            )}
          >
            {gatsbyImage && (
              <GatsbyImage
                className={styles.image}
                image={gatsbyImage}
                alt={title}
              />
            )}
          </div>
        )}
      </div>
    </Link>
  )
}

const BlogCardSkeleton = () => (
  <div
    // active
    // loading
    className={classnames(styles.card, styles.card__skeleton)}
  ></div>
)

BlogCard.Skeleton = BlogCardSkeleton
